module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.a323c28.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fonts/materialdesignicons-webfont.woff2?v=5.1.45
// module id = Zz2D
// module chunks = 1